import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Navigation } from 'swiper/modules';
import 'swiper/css/navigation';
import { motion, useInView } from 'framer-motion';
import Footer from './Footer';
const About = () => {
  const data = [
    {
      img: '/resume.jpeg',
      name: 'Cassidy',
      role: 'Developer',
    },
    {
      img: '/resume.jpeg',
      name: 'Cassidy',
      role: 'Developer',
    },
    {
      img: '/resume.jpeg',
      name: 'Cassidy',
      role: 'Developer',
    },
    {
      img: '/resume.jpeg',
      name: 'Cassidy',
      role: 'Developer',
    },
  ];
  return (
    <>
      <div className="bg-homeColor min-w-[280px]">
        <div className="bg-homeColor flex flex-col justify-center lg:flex-row">
          <motion.div
            className="bg-homeColor flex flex-col w-[90%] lg:w-[50%] justify-center mx-auto text-white items-center"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.8, duration: 1 }}
          >
            <h1 className="mt-32 font-bold text-5xl">
              About
              <span className="text-green ml-4">Us</span>
            </h1>
            <p className="w-[90%] text-left text-[18px] lg:text-xl mt-5  lg:w-[80%]">
              we don't just build digital solutions—we craft experiences that
              empower businesses to thrive in a rapidly evolving digital world.
              Specializing in custom Software development, web and app
              development, UI/UX design, social media marketing, SEO, and
              cutting-edge AI solutions, we're your one-stop hub for scaling
              your digital presence. Driven by innovation and rooted in
              strategy, we combine creative design, technical expertise, and
              data-driven insights to deliver impactful solutions that not only
              look good but also perform. Whether you're a startup aiming to
              make your mark or an established brand seeking growth, we align
              technology with your business goals to ensure measurable success.
            </p>
          </motion.div>
          <motion.div
            className="lg:mt-32 flex justify-center items-center w-[90%] lg:w-[50%] mx-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <img
              src="/rb_2148303918.png"
              loading="lazy"
              alt="Image description"
              className="w-full h-full"
            />
          </motion.div>
        </div>
        <div className="bg-homeColor mt-20 flex flex-col-reverse justify-center lg:flex-row">
          <div className="mt-10 flex justify-center items-center w-[90%] lg:w-[50%] mx-auto">
            <img
              src="/rb_717.png"
              loading="lazy"
              width="400px"
              height="400px"
              alt="Image description"
            />
          </div>
          <div className="bg-homeColor flex flex-col w-[90%] lg:w-[50%] justify-center mx-auto text-white items-center">
            <h1 className="mt-10 font-bold text-5xl">
              Who
              <span className="text-green ml-4">We Are</span>
            </h1>
            <p className="w-[90%] text-left text-xl mt-5  lg:w-[60%]">
              We are dedicated to transforming ideas into robust digital
              solutions. With a commitment to excellence, our team of skilled
              professionals leverages cutting-edge technologies to deliver
              high-quality software products tailored to meet the unique needs
              of our clients. From small startups to established enterprises, we
              empower businesses to thrive in a competitive landscape by
              providing scalable, efficient,and user-friendly software
              solutions.
            </p>
          </div>
        </div>
        {/* <div className="bg-homeColor mt-32 text-white flex flex-col items-center">
          <h1 className="text-center text-4xl font-bold ">
            Meet Our <span className="text-green">Professional Team</span>
          </h1>
          <p className="text-center mt-3 text-base w-3/5 sm:w-3/5 sm:text-xl">
            Contact us to meet our awesome team
          </p>
        </div>
        <div className="flex items-center justify-center flex-col h-[400px] relative bg-cardColor">
          <Swiper
            breakpoints={{
              340: {
                slidesPerView: 1,
                centeredSlides: true,
              },
              496: {
                slidesPerView: 2,
                spaceBetween: 5,
                centeredSlides: false,
              },
              700: {
                slidesPerView: 3,
                spaceBetween: 15,
                centeredSlides: false,
              },
            }}
            modules={[Navigation]}
            navigation={{
              prevEl: '.custom-swiper-button-prev',
              nextEl: '.custom-swiper-button-next',
            }}
            className="max-w-[90%] lg:max-w-[80%]"
          >
            {data.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="flex flex-col gap-6 mb-20 group relative text-white rounded-xl px-6 py-8 h-auto max-w-[95%] sm:max-w-[90%] lg:max-w-[90%] overflow-hidden cursor-pointer">
                  <div className="absolute inset-0 bg-cover bg-center" />
                  <div className="absolute inset-0 group-hover:opacity-50" />
                  <div className="relative flex flex-col items-center gap-3">
                    <img
                      src={item.img}
                      className="border-2 rounded-lg w-full h-auto lg:w-[400px] lg:h-[200px]"
                      alt={item.name}
                    />
                    <h1 className="text-xl lg:text-2xl">{item.name}</h1>
                    <p className="lg:text-[18px]">{item.role}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <button className="custom-swiper-button-prev text-white text-xs px-2 py-2 border-gray-300   absolute left-2 top-1/2 transform -translate-y-1/2  z-10">
            <FontAwesomeIcon
              icon={faAngleLeft}
              style={{ color: '#63E6BE', fontSize: '48px' }}
            />
          </button>
          <button className="custom-swiper-button-next  text-white text-xs border-gray-300   absolute right-2 top-1/2 transform -translate-y-1/2 z-10 ">
            <FontAwesomeIcon
              icon={faAngleRight}
              style={{ color: '#63E6BE', fontSize: '48px' }}
            />
          </button>
        </div> 
        <div className="flex flex-col mt-10 lg:mt-20 items-center text-white">
          <h1 className="text-center text-4xl font-bold ">
            Ready to Elevate
            <br /> Your
            <span className="text-green ml-4">Digital Strategy?</span>
          </h1>
          <p className="text-center mt-3 text-base w-3/5 sm:w-3/5 sm:text-xl">
            Whether you're a startup ready to make your mark or an established business looking to amplify your product's technical and digital strategy, our team is here to guide you.
          </p>
          <div className="flex flex-row flex-wrap gap-4 mt-20 w-full items-center justify-center">
            <input
              className="text-lg text-left w-[90%] sm:w-[80%] lg:w-[40%] shadow appearance-none border-gray-300 hover:border-2 hover:border-green focus:border-green focus:outline-none px-4 sm:px-2 py-4  rounded-3xl bg-cardColor"
              type="text"
              placeholder="Your Email"
            />
            <button className="w-[90%] sm:w-[80%] lg:w-[20%] text-homeColor bg-green border-green font-semibold rounded-3xl px-8 py-2">
              Get Started
            </button>
          </div>
        </div>*/}
        <Footer />
      </div>
    </>
  );
};
export default About;
